export default __webpack_public_path__ + "static/media/Grimshaker.cc571f0d.jpg";